export default function RiskMonitoringAndTestingDirective() {
  return {
    template: require('./risk-monitoring-and-testing.html'),
    scope: {
      assessmentId: '@',
      customerId: '@',
      assessmentCustomTestProcedure: '=',
      status: '=',
      includeKeyContacts: '@',
      canEdit: '<',
    },
    controller: 'RiskMonitoringAndTestingController',
    controllerAs: 'riskMonitoringAndTestingVM',
    bindToController: true,
    replace: true,
  };
}
